import { Injectable, Signal } from '@angular/core';
import { ICardData, ICardModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { CardActions, CardSelectors, ICardState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class CardStore extends StateAccessService<ICardState> {
  readonly state$: Observable<ICardState>;

  readonly data$$: Signal<ICardData>;
  readonly model$$: Signal<ICardModel>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(CardSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(CardSelectors.data);
  }

  dispatchCardReset() {
    this.stateFacade.dispatch(CardActions.reset());
  }
  dispatchCardLoad() {
    this.stateFacade.dispatch(CardActions.load());
  }
  dispatchCardLoadSuccess({ model, data }: { model: ICardModel; data: ICardData }) {
    this.stateFacade.dispatch(CardActions.loadSuccess({ model, data }));
  }
  dispatchCardSubmit() {
    this.stateFacade.dispatch(CardActions.submit());
  }
  dispatchCardSubmitSuccess({ model }: { model: ICardModel }) {
    this.stateFacade.dispatch(CardActions.submitSuccess({ model }));
  }
}
